import React from "react"

function IconRotate() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><title>ic_file_download_24px</title>
      <g fill="#111111">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path>
      </g>
    </svg>
  )
}

export default IconRotate